import { ProTable } from "@ant-design/pro-components";
import { Table } from "antd";
import CommonModal from "@/components/common/CommonModal";
import { ChildTableProps } from "@/utils/types/baseTable";

const ChildTable = <T extends object>({
  loading,
  columns,
  dataSource,
  headerTitle,
  rowKey,
  toolBarRender,
  scroll = {},
  search = false,
  showModal = false,
  modalTitle = "",
  modalContent,
  onModalClose,
  selectedRowKeys,
  setSelectedRowKeys,
  request,
}: ChildTableProps<T>) => {
  return (
    <>
      <ProTable<T>
        rowKey={rowKey}
        loading={loading}
        columns={columns}
        dataSource={dataSource}
        search={search ? {} : false}
        toolBarRender={toolBarRender}
        size="small"
        scroll={scroll}
        headerTitle={headerTitle}
        rowSelection={{
          selectedRowKeys,
          columnWidth: 60,
          onChange: newSelectedRowKeys =>
            setSelectedRowKeys?.(newSelectedRowKeys),
          selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
        }}
        options={false}
        request={request}
      />
      {showModal && (
        <CommonModal
          open={showModal}
          title={modalTitle}
          footer={null}
          onCancel={onModalClose}
          destroyOnClose
        >
          {modalContent}
        </CommonModal>
      )}
    </>
  );
};

export default ChildTable;
